<header id="page-topbar" class="isvertical-topbar color-fondo" [ngClass]="{ 'header-grande': collapsed }">
  <div class="nb" [ngClass]="{dev: !environment }">
    <div class="navbar-header">
      <div class="d-flex" [class.mobile-header-row]="isMobile">
        <!-- LOGO (desktop only — en mobile se usa el logo centrado) -->
        <div class="navbar-brand-box" *ngIf="!isMobile">
          <a href="#" class="logo logo-light">
            <span class="logo-lg">
              <img src="assets/images/logo-abbr-clear.png" alt="" height="22" />
            </span>
            <span class="logo-sm">
              <img src="assets/images/logo-abbr-clear.png" alt="" height="22" />
            </span>
          </a>
        </div>

        <button type="button"
          class="btn btn-sm px-3 font-size-16 header-item vertical-menu-btn topnav-hamburger"
          (click)="toggleSidebar.emit()">
          <span class="hamburger-icon">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>

        <!-- Logo centrado mobile -->
        <img *ngIf="isMobile" src="assets/images/logo-abbr-clear.png" alt="DBM"
          height="22" class="mobile-logo-center" />

        <!-- Lupa mobile (a la izquierda del avatar) -->
        <button *ngIf="isMobile && role != 'Sales'" type="button"
          class="btn header-item d-flex align-items-center mobile-search-trigger"
          (click)="openSearchOverlay()"
          [attr.aria-label]="'tooltip.search' | translate">
          <i class="icon-magnifier" aria-hidden="true"></i>
        </button>

        <!-- Avatar mobile (dentro del mismo d-flex que el hamburger) -->
        <button *ngIf="isMobile" type="button"
          class="btn header-item d-flex align-items-center mobile-avatar-trigger"
          (click)="openRightDrawer()">
          <img class="rounded-circle header-profile-user" [src]="userImageUrl || 'assets/images/user-empty.png'"
            alt="Header Avatar" />
        </button>
      </div>

      <!-- ===== DESKTOP: todos los botones del header ===== -->
      <div class="d-flex" *ngIf="!isMobile">
        <div *ngIf="role != 'Sales'" class="aux">
          <app-hea-filter></app-hea-filter>
        </div>
        <div class="dropdown d-inline-block">
          <button type="button" class="btn header-item noti-icon">
            <i class="icon-magnifier" [matTooltip]="'tooltip.search' | translate" aria-hidden="true"></i>
          </button>
        </div>

        <div class="dropdown d-inline-block">
          <button type="button" class="btn header-item noti-icon"
            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="icon-alarm" [matTooltip]="'tooltip.notif' | translate" aria-hidden="true"></i>
          </button>
          <span class="position-absolute icon-pill translate-middle badge rounded-pill" *ngIf="unreadCount > 0">
            {{unreadCount > 99 ? '99+' : unreadCount}}
            <span class="visually-hidden">unread notifications</span>
          </span>
          <div *ngIf=(notifications) class="dropdown-menu dropdown-menu-end pt-0 div-notif">
            <div class="p-3 border-bottom notif" *ngFor="let notification of notifications">
              <div [class.read]="isRead(notification.reference)">
                <a (click)="markAsRead(notification.reference)" href="{{notification.url}}">
                  <h6 class="mb-0 notif-title"> {{notification.title}}</h6>
                  <p class="mb-0 font-size-11 text-muted notif-content"> {{notification.content}}</p>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="menu-container" *ngIf="role != 'Sales'">
          <a href="inbox/my">
            <button type="button" class="btn header-item noti-icon">
              <i class="icon-archive2" [matTooltip]="'tooltip.inboxmy' | translate" aria-hidden="true"></i>
            </button>
            <span class="position-absolute icon-pill-inbox translate-middle badge2 rounded-pill"
              *ngIf="actionRequiredCountAgent > 0" class="badge2">{{ actionRequiredCountAgent > 999 ? '999+' : actionRequiredCountAgent }}
            </span>
          </a>
        </div>
        <div class="menu-container" *ngIf="showNotes && role != 'Sales'">
          <a href="inbox">
            <button type="button" class="btn header-item noti-icon">
              <i class="icon-inbox" [matTooltip]="'tooltip.inbox' | translate" aria-hidden="true"></i>
            </button>
            <span class="position-absolute icon-pill translate-middle badge rounded-pill"
              *ngIf="actionRequiredCount > 0" class="badge">{{ actionRequiredCount > 999 ? '999+' : actionRequiredCount }}
            </span>
          </a>
        </div>
        <div class="menu-container" *ngIf="showNotes && role != 'Sales'">
          <a href="private-inbox">
            <button type="button" class="btn header-item noti-icon">
              <i class="icon-inbox" [matTooltip]="'tooltip.inboxprivate' | translate" aria-hidden="true"></i>
            </button>
            <span class="position-absolute icon-pill translate-middle badge rounded-pill"
              *ngIf="privateActionRequiredCount > 0" class="badge">{{ privateActionRequiredCount > 999 ? '999+' : privateActionRequiredCount }}
            </span>
          </a>
        </div>

        <div class="dropdown d-inline-block">
          <a href="https://help.digitalbuyersmanager.com/" target="_blank">
            <button type="button" class="btn header-item noti-icon">
              <i class="icon-question-circle" [matTooltip]="'tooltip.help' | translate" aria-hidden="true"></i>
            </button>
          </a>
        </div>
        <div class="dropdown d-inline-block">
          <a *ngIf="role == 'Admin'" routerLink="/settings">
            <button type="button" class="btn header-item noti-icon">
              <i class="icon-cog" [matTooltip]="'tooltip.config' | translate" aria-hidden="true"></i>
            </button>
          </a>
        </div>

        <div class="dropdown d-inline-block">
          <button type="button" class="btn header-item user text-start d-flex align-items-center"
            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span> {{'language' | translate}}</span>
          </button>
          <div class="dropdown-menu dropdown-menu-end pt-0">
            <button type="button" class="div-profile gap10" *ngFor="let lang of languages" (click)="changeLanguage(lang)"
                    [attr.aria-label]="'Cambiar idioma a ' + ('languages.' + lang.language | translate)">
              <span> {{"languages." + lang.language | translate}}</span> <i class="icon-check"
                *ngIf="selectedLanguage.code == lang.code" aria-hidden="true"></i>
            </button>
          </div>
        </div>

        <div class="dropdown d-inline-block">
          <button type="button" class="btn header-item user text-start d-flex align-items-center"
            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img class="rounded-circle header-profile-user" [src]="userImageUrl || 'assets/images/user-empty.png'"
              alt="Header Avatar" />
          </button>
          <div class="dropdown-menu dropdown-menu-end pt-0">
            <!-- 1. Account name -->
            <div class="p-3 border-bottom">
              <h6 class="mb-0">{{ activeSessionName || 'DBM' }}</h6>
              <p class="mb-0 font-size-11 text-muted">{{ activeSessionAccount || 'digitalbuyersmanager' }}</p>
            </div>

            <!-- 2. My Profile + Logout -->
            <a href="/settings/profile" class="dropdown-action-item">
              <span class="dropdown-action-icon"><i class="icon-user" aria-hidden="true"></i></span>
              <span>{{"settings.profile.my-profile" | translate}}</span>
            </a>

            <button type="button" class="dropdown-action-item dropdown-action-logout" (click)="logout()"
                    [attr.aria-label]="'logout' | translate">
              <span class="dropdown-action-icon dropdown-action-icon-logout"><i class="icon-exit" aria-hidden="true"></i></span>
              <span>{{ "multi_account.logout_current" | translate }}</span>
            </button>

            <!-- 3. Other accounts + Add account -->
            <div *ngIf="sessions.length > 1" class="session-list-section">
              <div class="dropdown-divider"></div>
              <div class="px-3 py-1">
                <small class="text-muted" style="font-size:10px">{{ 'multi_account.other_accounts' | translate }}</small>
              </div>
              <ng-container *ngFor="let s of sessions; let i = index">
                <button *ngIf="i !== activeSessionIndex"
                  class="div-profile session-item"
                  (click)="onSwitchAccount(i)"
                  style="padding:4px 12px;gap:8px;align-items:center">
                  <img class="rounded-circle session-avatar-img"
                    [src]="s.img || 'assets/images/user-empty.png'" alt="" />
                  <span class="session-info" style="line-height:1.2">
                    <span style="font-size:12px;font-weight:500;display:block">{{ s.name }}</span>
                    <span style="font-size:10px;color:#888;display:block">{{ s.account_name }} · {{ s.role }}</span>
                  </span>
                </button>
              </ng-container>
            </div>

            <div *ngIf="sessions.length <= 1" class="dropdown-divider"></div>

            <button *ngIf="sessions.length < 5" type="button" class="dropdown-action-item"
              (click)="onAddAccount()">
              <span class="dropdown-action-icon"><i class="icon-plus" aria-hidden="true"></i></span>
              <span>{{ 'multi_account.add_account' | translate }}</span>
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</header>

<!-- ============================
     DRAWER DERECHO (mobile only)
     ============================ -->
<div *ngIf="isMobile && rightDrawerOpen" class="right-drawer-backdrop" (click)="closeRightDrawer()"></div>

<div *ngIf="isMobile" class="right-drawer" [class.open]="rightDrawerOpen" role="dialog" aria-label="Menu de usuario">
  <!-- Cabecera con avatar -->
  <div class="drawer-header">
    <img class="rounded-circle" [src]="userImageUrl || 'assets/images/user-empty.png'"
      alt="Avatar" width="40" height="40" />
    <div>
      <div class="drawer-name">{{ activeSessionName || 'DBM' }}</div>
      <div class="drawer-account">{{ activeSessionAccount || 'digitalbuyersmanager' }}</div>
    </div>
  </div>

  <!-- Notificaciones -->
  <button class="drawer-item" (click)="drawerNotificationsExpanded = !drawerNotificationsExpanded">
    <i class="icon-alarm" aria-hidden="true"></i>
    <span>{{"tooltip.notif" | translate}}</span>
    <span class="drawer-badge" *ngIf="unreadCount > 0">{{unreadCount > 99 ? '99+' : unreadCount}}</span>
    <i [class]="drawerNotificationsExpanded ? 'icon-chevron-up' : 'icon-chevron-down'" class="drawer-chevron" aria-hidden="true"></i>
  </button>
  <div *ngIf="drawerNotificationsExpanded" class="drawer-submenu">
    <div class="drawer-notif-item" *ngFor="let notification of notifications">
      <a (click)="markAsRead(notification.reference); onDrawerNavigate()" href="{{notification.url}}"
        [class.read]="isRead(notification.reference)">
        <div class="drawer-notif-title">{{notification.title}}</div>
        <div class="drawer-notif-content">{{notification.content}}</div>
      </a>
    </div>
    <div *ngIf="!notifications?.length" class="drawer-notif-empty">
      {{"tooltip.no-notif" | translate}}
    </div>
  </div>

  <!-- Inboxes -->
  <a class="drawer-item" href="inbox/my" (click)="onDrawerNavigate()" *ngIf="role != 'Sales'">
    <i class="icon-archive2" aria-hidden="true"></i>
    <span>{{"tooltip.inboxmy" | translate}}</span>
    <span class="drawer-badge" *ngIf="actionRequiredCountAgent > 0">{{actionRequiredCountAgent}}</span>
  </a>
  <a class="drawer-item" href="inbox" (click)="onDrawerNavigate()" *ngIf="showNotes && role != 'Sales'">
    <i class="icon-inbox" aria-hidden="true"></i>
    <span>{{"tooltip.inbox" | translate}}</span>
    <span class="drawer-badge" *ngIf="actionRequiredCount > 0">{{actionRequiredCount}}</span>
  </a>
  <a class="drawer-item" href="private-inbox" (click)="onDrawerNavigate()" *ngIf="showNotes && role != 'Sales'">
    <i class="icon-inbox" aria-hidden="true"></i>
    <span>{{"tooltip.inboxprivate" | translate}}</span>
    <span class="drawer-badge" *ngIf="privateActionRequiredCount > 0">{{privateActionRequiredCount}}</span>
  </a>

  <!-- Ayuda -->
  <a class="drawer-item" href="https://help.digitalbuyersmanager.com/" target="_blank" (click)="onDrawerNavigate()">
    <i class="icon-question-circle" aria-hidden="true"></i>
    <span>{{"tooltip.help" | translate}}</span>
  </a>

  <!-- Settings (Admin) -->
  <a class="drawer-item" routerLink="/settings" (click)="onDrawerNavigate()" *ngIf="role == 'Admin'">
    <i class="icon-cog" aria-hidden="true"></i>
    <span>{{"tooltip.config" | translate}}</span>
  </a>

  <!-- Idioma -->
  <button class="drawer-item" (click)="drawerLanguageExpanded = !drawerLanguageExpanded">
    <i class="icon-earth" aria-hidden="true"></i>
    <span>{{'language' | translate}}</span>
    <i [class]="drawerLanguageExpanded ? 'icon-chevron-up' : 'icon-chevron-down'" class="drawer-chevron" aria-hidden="true"></i>
  </button>
  <div *ngIf="drawerLanguageExpanded" class="drawer-submenu">
    <button class="drawer-item drawer-subitem" *ngFor="let lang of languages" (click)="onDrawerLanguageChange(lang)">
      <span>{{"languages." + lang.language | translate}}</span>
      <i class="icon-check" *ngIf="selectedLanguage.code == lang.code" aria-hidden="true"></i>
    </button>
  </div>

  <!-- Perfil + Logout -->
  <div class="drawer-separator"></div>

  <a class="drawer-item" href="/settings/profile" (click)="onDrawerNavigate()">
    <i class="icon-user" aria-hidden="true"></i>
    <span>{{"settings.profile.my-profile" | translate}}</span>
  </a>

  <button class="drawer-item drawer-logout" (click)="logout()">
    <i class="icon-exit" aria-hidden="true"></i>
    <span>{{ "multi_account.logout_current" | translate }}</span>
  </button>

  <!-- Multi-account: session list (mobile) -->
  <div *ngIf="sessions.length > 1">
    <div class="drawer-separator"></div>
    <div class="px-3 py-1"><small class="text-muted" style="font-size:10px">{{ 'multi_account.other_accounts' | translate }}</small></div>
    <ng-container *ngFor="let s of sessions; let i = index">
      <button *ngIf="i !== activeSessionIndex"
        class="drawer-item"
        (click)="onSwitchAccount(i); onDrawerNavigate()"
        style="padding:6px 16px;gap:8px;align-items:center">
        <img class="rounded-circle session-avatar-img"
          [src]="s.img || 'assets/images/user-empty.png'" alt="" />
        <span style="line-height:1.2">
          <span style="font-size:12px;font-weight:500;display:block">{{ s.name }}</span>
          <span style="font-size:10px;color:#888;display:block">{{ s.account_name }} · {{ s.role }}</span>
        </span>
      </button>
    </ng-container>
  </div>

  <div *ngIf="sessions.length <= 1" class="drawer-separator"></div>

  <button *ngIf="sessions.length < 5" class="drawer-item" (click)="onAddAccount(); onDrawerNavigate()"
    style="padding:6px 16px;gap:8px;align-items:center">
    <span class="session-add-icon"><i class="icon-plus" aria-hidden="true"></i></span>
    <span style="font-size:12px">{{ 'multi_account.add_account' | translate }}</span>
  </button>
</div>

<!-- ============================
     SEARCH OVERLAY (mobile only)
     ============================ -->
<app-search-overlay *ngIf="searchOverlayOpen" (closeOverlay)="closeSearchOverlay()"></app-search-overlay>

<!-- Keyboard shortcuts widget + cheatsheet -->
<button *ngIf="!isMobile"
  class="shortcuts-fab"
  (click)="cheatsheetVisible = !cheatsheetVisible"
  [matTooltip]="'keyboard.title' | translate"
  matTooltipPosition="left"
  aria-label="Keyboard shortcuts">
  <span class="shortcuts-fab-key">?</span>
</button>
<app-keyboard-cheatsheet [visible]="cheatsheetVisible" (close)="cheatsheetVisible = false"></app-keyboard-cheatsheet>

<!-- Multi-account: relogin modal for expired sessions -->
<app-relogin-modal *ngIf="reloginSession" [session]="reloginSession" (success)="onReloginSuccess($event)" (cancel)="reloginSession = null"></app-relogin-modal>
